import { render, staticRenderFns } from "./CNAEField.vue?vue&type=template&id=d850e1f8&scoped=true&"
import script from "./CNAEField.vue?vue&type=script&lang=js&"
export * from "./CNAEField.vue?vue&type=script&lang=js&"
import style0 from "./CNAEField.vue?vue&type=style&index=0&id=d850e1f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d850e1f8",
  null
  
)

export default component.exports